// src/getToken.client.ts
async function getToken(opts) {
  const clerk = globalThis.Clerk;
  if (!clerk)
    return null;
  if (!clerk.loaded)
    await clerk.load();
  return await clerk.session?.getToken(opts) ?? null;
}
export {
  getToken
};
